import React from 'react'
import './customizedModal.css'
import { useTheme } from '../../contextProviders';

const CustomizedModal = ({
  closeButton = true,
  shouldCloseOnEsc = true,
  isOpen = false,
  title,
  onClose,
  children,
  shouldCloseOnOverlayClick = true,
  containerDimensions = '100vw, 100vh',
}) => {
  if (!isOpen) return null;
  const { isDarkMode } = useTheme();

  const handleOverlayClick = (e) => {
    if (shouldCloseOnOverlayClick && e.target === e.currentTarget) {
      onClose();
    }
  };

  // Split containerDimensions into width and height
  const [width, height] = containerDimensions.split(',');

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
      onClick={handleOverlayClick}
    >
      <div
        className={`relative p-6 rounded-lg shadow-lg customMobStyleModal ${isDarkMode ? "bg-primary-dark text-white" : "bg-white text-black"}`}
        style={{ width: width.trim(), height: height.trim() }}
      >
        {closeButton && (
          <button
            className={` ${isDarkMode ? "text-white" : "text-black"} absolute top-4 right-4 text-3xl`}
            onClick={onClose}
          >
            &times;
          </button>
        )}
        {title && <h2 className="text-xl font-bold mb-1">{title}</h2>}
        <hr />
        <div className="modal-content mt-4">
          {children}
        </div>
      </div>
    </div>
  );
};

export default CustomizedModal
